<template>
  <portal to="modals" :disabled="disablePortal">
    <div
      class="modal-backdrop z-20 w-full scrolling-touch"
      @click.self="outsideClose"
    >
      <div
        class="modal"
        :style="[
          partners ? '' : { 'max-width': `${max_width}px` },
          { 'min-width': `${min_width}px` },
          { 'max-height': `${max_height}px` },
          { width: widthAuto ? 'auto' : `${width}px` },
          { height: `${height}px` },
        ]"
        :class="{
          wide: wide,
          partners: partners,
          'new-partners': new_partners,
          'application-adding': application_adding,
        }"
      >
        <div class="flex flex-col w-full relative bg-white">
          <div id="cir" class="z-70 bg-brand-dark">
            <div
              class="
                h-32
                lg:h-40
                xl:h-40
                md:h-32
                iphone-head-height
                relative
                flex
                items-center
                justify-center
                flex-col
                header-bg
                bg-cover
                md:bg-contain
                z-50
              "
              v-if="$slots.header"
            >
              <img
                src="@/assets/SVG/white-cross.svg"
                class="
                  absolute
                  text-white
                  pin-t pin-r
                  mr-4
                  mt-6
                  cursor-pointer
                  text-xl
                  z-50
                  h-4
                "
                @click="$emit('close')"
              />
              <div class="text-white font-medium px-4 text-center">
                <slot name="header"></slot>
              </div>
            </div>
          </div>

          <div
            class="bg-white relative p-2"
            :class="{
              'pt-16 -mt-16': !wide,
              'pt-24 -mt-24': wide,
              long: long,
              '': isPhone === 'mobile' && isRegistration,
              '': isPhone === 'desktop' && isRegistrationDesktop,
            }"
          >
            <slot></slot>
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import isMobile from '@/mixins/isMobile.js';

export default {
  name: 'modal',
  mixins: [isMobile],
  props: {
    wide: {
      type: Boolean,
      default: false,
    },
    click_outside: {
      type: Boolean,
      default: true,
    },
    isRegistration: {
      type: Boolean,
      default: false,
    },
    isRegistrationDesktop: {
      type: Boolean,
      default: false,
    },
    max_width: {
      type: Number,
      default: 360,
    },
    min_width: {
      type: Number,
    },
    max_height: {
      type: Number,
    },
    width: {
      type: Number,
    },
    widthAuto: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
    },
    partners: {
      type: Boolean,
      default: false,
    },
    new_partners: {
      type: Boolean,
      default: false,
    },
    application_adding: {
      type: Boolean,
      default: false,
    },
    long: {
      type: Boolean,
      default: false,
    },
    disablePortal: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    document.body.classList.add('overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  },
  computed: {
    isPhone() {
      return this.isMobile;
    },
  },
  methods: {
    outsideClose() {
      if (this.click_outside === true) this.$emit('close');
    },
  },
};
</script>

<style scoped>
.header-bg {
  background-image: url("../../assets/SVG/heading.svg");
  background-repeat: no-repeat;
  margin: -5px -1px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: grid;
  place-content: center;
}

.modal {
  width: 340px;
  overflow-y: auto;
}

.modal.wide {
  max-width: 655px;
  width: 100%;
}

.modal.partners {
  max-width: 505px;
  width: 100%;
}

.modal.new-partners {
  max-width: 320px;
  width: 100%;
}

.modal.application-adding {
  max-width: 775px;
  width: 100%;
}

.modal {
  border-radius: 0.85rem;
  -webkit-box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

#cir {
  clip-path: ellipse(63% 85% at 50% 0%);
  margin-left: -1px;
}

.long {
  padding-top: 20px !important;
  @apply rounded-lg;
  margin-top: 700px !important;
  margin-bottom: 70px !important;
}

@media only screen and (min-width: 319px) and (max-width: 330px) {
  .iphone-head-height {
    height: 5.6rem !important;
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>
